<template>
  <!-- eslint-disable max-len -->
  <div class="card shadow border-0 p-0 h-100">
    <h4
      v-if="isHighlight"
      class="highlight letter-spacing-wide font-weight-bold font-size-sm mb-0 py-1 px-2 text-center
             text-uppercase position-absolute py-2 w-100 h3"
    >
      AppSumo Loved
    </h4>
    <div class="d-flex flex-column flex-grow-1 justify-content-between planContainer">
      <div>
        <div
          class="price"
          align="center"
        >
          <h4 class="border-bottom mb-0 py-4 px-3">
            {{ name }}
          </h4>

          <div v-if="showPricingInfo" class="pt-3 border-bottom">
            <p v-if="description =='One Time Purchase of'" class="mb-0 font-size-md">
              One-time purchase of
            </p>
            <p
              v-else
              class="mb-0 font-size-md"
            >
              {{ sentenceCase(description) }}
            </p>

            <div class="price-line d-flex align-items-center justify-content-center pb-3">
              <span class="font-size-lg font-weight-bold">
                {{ price | currencyWithOptionalDecimal }}
              </span>
              <span
                v-if="originalPrice"
                class="border-left ml-2 pl-2 original-price text-muted"
              >
                {{ originalPrice | currencyWithOptionalDecimal }}
              </span>
            </div>
          </div>
        </div>

        <ul class="mb-3 px-3 py-4 text-muted feature-list">
          <li
            v-if="hasAllFeatures"
            class="d-flex mb-2"
          >
            <span class="pl-1 break-word-all">All features above included</span>
          </li>
          <li
            v-for="(feature, fIndex) in features"
            :key="fIndex"
            class="d-flex mb-2"
          >
            <!-- eslint-disable vue/no-v-html-->
            <span
              class="pl-1 feature-block break-word-all"
              v-html="parseFeature(feature, tier)"
            />
            <!-- eslint-enable vue/no-v-html-->
          </li>
        </ul>
      </div>

      <div>
        <slot name="options" />
        <slot name="cta" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    isHighlight: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    price: {
      type: [String, Number],
      required: true,
    },
    originalPrice: {
      type: [String, Number, null],
      required: true,
    },
    hasAllFeatures: {
      type: Boolean,
      default: false,
    },
    features: {
      type: Array,
      required: true,
    },
    ctaText: {
      type: String,
      required: true,
    },
    tier: {
      type: [String, Number],
      required: true,
    },
    showPricingInfo: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    parseFeature(feature) {
      // Add bold to templated slugs (like django)
      if (!feature.code_to_feature_conf) {
        return feature.feature;
      }

      const { quantity } = feature.code_to_feature_conf[this.tier - 1] || {};
      return feature.feature.replace('{{}}', `<b>${quantity || '&nbsp'}</b>`);
    },
    sentenceCase(str) {
      const newString = str.toLowerCase().replace(/(^\s*\w|[.!?]\s*\w)/g, (c) => c.toUpperCase());
      return newString;
    },
  },
};
</script>

<style lang="scss" scoped>
  .highlight {
    transform: translateY(-100%);
  }

  .feature-block ::v-deep b {
    color: #000;
  }

  .price-line {
    font-size: 1.25rem;

    .original-price {
      text-decoration: line-through;
    }
  }

  .feature-list {
    padding: 0;

    li {
      list-style-type: none;
      padding: 0 0 0 1.75rem;
      position: relative;
      line-height: 24px;
      font-size: 1rem;

      &::before {
        content: ' ';
        display: block;
        width: 7px;
        height: 14px;
        border: solid #07c03b;
        border-width: 0 2px 2px 0;
        position: absolute;
        left: 4px;
        top: 2px;
        transform: rotate(45deg);
      }
    }
  }
</style>
